module.exports = __webpack_public_path__ + "img/bg1.84b6cec1.png";